module.exports = __webpack_public_path__ + "static/media/frauen_eticket.2441b0b7.jpg";